/**
 *  @class
 *  @function RedemptionForm
 */

if (!customElements.get('redemption-form')) {
  class RedemptionForm extends HTMLElement {
    constructor() {
      super();
      this.iframe = this.querySelector('iframe');
      this.scriptPath = 'https://cdn.jsdelivr.net/npm/@iframe-resizer/parent';

      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var code = urlParams.get('code');

      var frameUrl = new URL(this.iframe.src);

      if (code) frameUrl.searchParams.set('code', code);

      this.iframe.src = frameUrl.href;
    }

    loadScript = () => {
      var js = document.createElement('script');
      js.src = this.scriptPath;
      js.onload = () => this.setUpIframe();
      document.head.appendChild(js);
    };

    setUpIframe = () => {
      iframeResize({
        license: 'GPLv3',
        waitForLoad: true,
      }, '#' + this.iframe.id );
    };

    connectedCallback() {
      this.loadScript();
    }
  }

  customElements.define('redemption-form', RedemptionForm);
}